import { useState } from "react";
import { Plus, Trash2 } from "lucide-react";
import { getCustomQuestions, saveCustomQuestions } from "@/lib/dinner";

export const CustomQuestions = ({ onChange }) => {
  const [items, setItems] = useState(getCustomQuestions());
  const [q, setQ] = useState("");

  const update = (next) => { setItems(next); saveCustomQuestions(next); onChange(); };
  const add = (e) => {
    e.preventDefault();
    const t = q.trim();
    if (!t || items.includes(t)) return;
    update([...items, t.endsWith("?") || t.endsWith(".") || t.endsWith("!") ? t : `${t}?`]);
    setQ("");
  };

  return (
    <div className="pp-custom-q" data-testid="custom-questions">
      <p className="pp-label">Our family's questions</p>
      <p className="text-sm opacity-75">Add inside jokes, faith questions or family favorites. They join the game and the printouts.</p>
      <form onSubmit={add} className="flex gap-2 mt-3">
        <input className="pp-input pp-custom-input" value={q} maxLength={160} placeholder="What made you laugh this week?"
          onChange={(e) => setQ(e.target.value)} data-testid="custom-question-input" />
        <button className="pp-primary" aria-label="Add question" data-testid="custom-question-add"><Plus className="h-5 w-5" /></button>
      </form>
      <ul className="mt-3 space-y-2">
        {items.map((it, i) => (
          <li key={it} className="pp-custom-row" data-testid={`custom-question-${i}`}>
            <span>{it}</span>
            <button className="pp-icon" onClick={() => update(items.filter((x) => x !== it))} aria-label="Remove question"
              data-testid={`custom-question-remove-${i}`}><Trash2 className="h-4 w-4" /></button>
          </li>
        ))}
      </ul>
    </div>
  );
};
